export class Degree {
    id : number;
    degreeCode : string;
    degreeName : string;
}